<ng-container *transloco="let t; read: 'warn-snackbar'">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div>
      <app-value value="Warning" [bgFill]="true" [warn]="true"></app-value>
      {{ data.message }}
    </div>
    <button mat-button (click)="dismiss()" color="accent">{{ t('Dismiss') }}</button>
  </div>
</ng-container>
